// ========================================
// Unify Event Tracker Widget
// ========================================

function initUnifyEventTracker() {
    // Check if we're on the cart page 
    if (!document.body.classList.contains('cart')) {
        return;
    }

    // Create the unify-event-tracker element and add it to the page, to be able to track events from the Unify Widgets
    const unifyEventTracker = document.createElement('unify-event-tracker-widget');
    unifyEventTracker.setAttribute('api-key', UNIFY_WIDGET_API_KEY);
    document.body.appendChild(unifyEventTracker);

    // Create a util function to let other scripts track events on the Unify Event Tracker
    window.addUnifyEvent = function(eventName, eventData) {
        const eventTracker = document.querySelector('unify-event-tracker-widget');

        // Get the sent event data, and the location_id, the user_id, and the currently logged-in user to the event data
        //wshopStoreCode for location_id
        const locationId = getCookie('wshopStoreCode') || '';
        const userId = getCookie('sellerWPOSId') || '';

        const payload = Object.assign({}, eventData, {
            location_id: locationId,
            user_id: userId,
        });

        if (eventTracker) {
            return eventTracker.event(eventName, payload);
        }

        console.error("Unify Event Tracker not found on the page!");
        return Promise.reject(new Error("Unify Event Tracker not found on the page!"));
    }

    window.shareBasketWithUnify = async function(defaultUrl, eventData, useNativeShare) {
        let sharedUrl = defaultUrl;

        try {
            if (typeof window.addUnifyEvent === 'function') {
                const response = await window.addUnifyEvent('basket.shared', eventData);

                if (response && response.shared_url) {
                    sharedUrl = response.shared_url;
                }
            }
        } catch (error) {
            console.error('Unable to generate Unify shared basket URL', error);
        }

        return useNativeShare ? invokeNativeShare(sharedUrl) : copyToClipboard(sharedUrl);
    }
}

// ========================================
// Unify Store Availability Widget (Click & Go)
// ========================================

const unifyWidgetState = {
    storeAvailabilityWidget: null,
    storeAvailabilityOpenButton: null,
    eresaWidget: null,
    eresaOpenButton: null,
    stockWidget: null,
    stockGlobalListenersBound: false,
};

function handleStorePickup(event) {
    var setSessionConveyorData = {
        'conveyor_id': 24,
        'relay_id': event.detail.location.location_id
    };

    const productInfoForm = document.querySelector('.product-infos-form');
    if (!productInfoForm) {
        return;
    }

    var addPanierData = {
        data: productInfoForm.getAttribute('data-panier-id'),
        productId: productInfoForm.getAttribute('data-product-id'),
        colorId: productInfoForm.getAttribute('data-product-color'),
        sizeId: productInfoForm.getAttribute('data-product-size'),
    };

    fetch(path_relative_root + 'ajax_set_session_conveyor.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(setSessionConveyorData)
    })
        .then(response => response.json())
        .then(res => {
            if (res.success === true) {
                return fetch(path_relative_root + "ajax_add_panier_wishlist.php", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(addPanierData)
                });
            }
        })
        .then(response => response.text())
        .then(resp => {
            if (resp === "ok") {
                location.href = path_relative_root + create_link('order_livraison_choix');
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
}

function onClickAndGoItemSizeChangeComplete() {
    const unifyWidget = unifyWidgetState.storeAvailabilityWidget;
    if (unifyWidget) {
        unifyWidget.open = true;
    }
    document.removeEventListener('onItemSizeChange_complete', onClickAndGoItemSizeChangeComplete);
}

function onClickAndGoSizeSelectedFromModal() {
    document.removeEventListener('onItemSizeChange_complete', onClickAndGoItemSizeChangeComplete);
    document.addEventListener('onItemSizeChange_complete', onClickAndGoItemSizeChangeComplete);
    document.removeEventListener('sizeSelectedFromModal', onClickAndGoSizeSelectedFromModal);
}

function onClickAndGoCloseModal() {
    document.removeEventListener('sizeSelectedFromModal', onClickAndGoSizeSelectedFromModal);
}

function handleClickAndGoButtonClick(event) {
    const unifyWidget = unifyWidgetState.storeAvailabilityWidget;
    if (!unifyWidget) {
        return;
    }

    const button = unifyWidgetState.storeAvailabilityOpenButton;
    const form = button ? button.closest('.product-infos-form') : null;
    const ean = form ? form.getAttribute('data-product-ean') : '';

    if (ean) {
        unifyWidget.setAttribute('item-id', ean);
    } else {
        unifyWidget.removeAttribute('item-id');
    }

    if (!unifyWidget.getAttribute('item-id') || unifyWidget.getAttribute('item-id') === '') {
        btnHandler_withoutSize(event);

        document.removeEventListener('sizeSelectedFromModal', onClickAndGoSizeSelectedFromModal);
        document.addEventListener('sizeSelectedFromModal', onClickAndGoSizeSelectedFromModal);

        document.removeEventListener('closeModal', onClickAndGoCloseModal);
        document.addEventListener('closeModal', onClickAndGoCloseModal);

        return;
    }

    unifyWidget.open = true;
}

function onEresaItemSizeChangeComplete() {
    const unifyEresaWidget = unifyWidgetState.eresaWidget;
    if (unifyEresaWidget) {
        unifyEresaWidget.open = true;
    }
    document.removeEventListener('onItemSizeChange_complete', onEresaItemSizeChangeComplete);
}

function onEresaSizeSelectedFromModal() {
    document.removeEventListener('onItemSizeChange_complete', onEresaItemSizeChangeComplete);
    document.addEventListener('onItemSizeChange_complete', onEresaItemSizeChangeComplete);
    document.removeEventListener('sizeSelectedFromModal', onEresaSizeSelectedFromModal);
}

function onEresaCloseModal() {
    document.removeEventListener('sizeSelectedFromModal', onEresaSizeSelectedFromModal);
    document.removeEventListener('closeModal', onEresaCloseModal);

    const restoredStockElements = [];
    document.querySelectorAll('#size-selector .product-sizes .size > label').forEach(sizeElement => {
        if (sizeElement.hasAttribute('temp-no-stock')) {
            sizeElement.setAttribute('no-transition', '');
            sizeElement.setAttribute('no-stock', '');
            sizeElement.removeAttribute('temp-no-stock');
            restoredStockElements.push(sizeElement);
        }
    });
    if (restoredStockElements.length) {
        restoredStockElements[0].offsetHeight; // force reflow once to commit all changes above without animating
        restoredStockElements.forEach(el => el.removeAttribute('no-transition'));
    }
}

function handleEresaButtonClick(event) {
    const unifyEresaWidget = unifyWidgetState.eresaWidget;
    if (!unifyEresaWidget) {
        return;
    }

    const button = unifyWidgetState.eresaOpenButton;
    const form = button ? button.closest('.product-infos-form') : null;
    const ean = form ? form.getAttribute('data-product-ean') : '';
    const price = form ? form.getAttribute('data-prixu') : null;

    if (ean) {
        unifyEresaWidget.setAttribute('item-id', ean);
    } else {
        unifyEresaWidget.removeAttribute('item-id');
    }

    if (price) {
        unifyEresaWidget.price = parseFloat(price);
    }

    if (!unifyEresaWidget.getAttribute('item-id') || unifyEresaWidget.getAttribute('item-id') === '') {
        const hiddenStockElements = [];
        document.querySelectorAll('#size-selector .product-sizes .size > label').forEach(sizeElement => {
            if (sizeElement.hasAttribute('no-stock')) {
                sizeElement.setAttribute('no-transition', '');
                sizeElement.setAttribute('temp-no-stock', '');
                sizeElement.removeAttribute('no-stock');
                hiddenStockElements.push(sizeElement);
            }
        });
        if (hiddenStockElements.length) {
            hiddenStockElements[0].offsetHeight; // force reflow once to commit all changes above without animating
            hiddenStockElements.forEach(el => el.removeAttribute('no-transition'));
        }

        btnHandler_withoutSize(event);

        document.removeEventListener('sizeSelectedFromModal', onEresaSizeSelectedFromModal);
        document.addEventListener('sizeSelectedFromModal', onEresaSizeSelectedFromModal);

        document.removeEventListener('closeModal', onEresaCloseModal);
        document.addEventListener('closeModal', onEresaCloseModal);

        return;
    }

    unifyEresaWidget.open = true;
}

function hideAlertStockButton() {
    const alertStockButton = document.querySelector('.product-add-alert-button');
    if (alertStockButton) {
        alertStockButton.setAttribute('is-hidden', '');
    }
}

function handleUnifyStockWidgetAddToCart(event) {
    const unifyWidget = unifyWidgetState.stockWidget;
    if (!event.detail.source) {
        const addToCartButton = unifyWidget ? unifyWidget.querySelector('[slot="add-to-cart-btn"]') : null;
        if (addToCartButton) {
            addToCartButton.removeAttribute('is-loading');
        }

        console.error('Stock source not defined in add-to-cart event from Unify Stock Widget', { event });

        if (!document.querySelector('.unify-stock-widget-error-message') && unifyWidget) {
            unifyWidget.insertAdjacentHTML('afterend', `
                <p class="unify-stock-widget-error-message">${Translator.translate('item_interaction_no_stock_source')}</p>
            `);
        }
        return;
    }

    const productInfoForm = document.querySelector('.product-infos-form');
    addToBasket(productInfoForm);
}

function handleUnifyStockWidgetSourceChange(event) {
    const errorMessageElem = document.querySelector('.unify-stock-widget-error-message');
    if (errorMessageElem) {
        errorMessageElem.remove();
    }

    const productInfoForm = document.querySelector('.product-infos-form');
    if (productInfoForm) {
        // setAttribute stringifies its value, so a null/undefined locationId would set the literal text "null"/"undefined"
        if (event.detail.source === 'location' && event.detail.locationId !== null && event.detail.locationId !== undefined) {
            productInfoForm.setAttribute('data-stock-location', event.detail.locationId);
        } else {
            productInfoForm.setAttribute('data-stock-location', '');
        }
    }
}

function handleUnifyStockWidgetErrorDismiss() {
    const errorMessageElem = document.querySelector('.unify-stock-widget-error-message');
    if (errorMessageElem) {
        errorMessageElem.remove();
    }
}

function handleUnifyStockWidgetAddToBasketError() {
    const unifyWidget = unifyWidgetState.stockWidget;
    if (!unifyWidget) {
        return;
    }

    unifyWidget.insertAdjacentHTML('afterend', `
        <p class="unify-stock-widget-error-message">${Translator.translate('purchase_confirmation_error')}</p>
    `);

    document.removeEventListener('click', handleUnifyStockWidgetErrorDismiss);
    document.addEventListener('click', handleUnifyStockWidgetErrorDismiss);
}

function initUnifyStoreAvailabilityWidget() {
    // Check if the body has a .product_page class, if not, exit
    if (!document.body.classList.contains('product_page')) {
        return;
    }
    const unifyWidget = document.querySelector('unify-store-availability-widget');

    if (unifyWidget) {
        if (unifyWidgetState.storeAvailabilityWidget && unifyWidgetState.storeAvailabilityWidget !== unifyWidget) {
            unifyWidgetState.storeAvailabilityWidget.removeEventListener('store-pickup', handleStorePickup);
        }

        unifyWidgetState.storeAvailabilityWidget = unifyWidget;

        unifyWidget.removeEventListener('store-pickup', handleStorePickup);
        unifyWidget.addEventListener('store-pickup', handleStorePickup);

        unifyWidget.config = {
            // Translations
            "dialogTitle": Translator.translate('clickandgo_dialog_title'),
            "dialogDescription": Translator.translate('clickandgo_dialog_description'),
            "addressLabel": Translator.translate('clickandgo_dialog_address_label'),
            "addressPlaceholder": Translator.translate('clickandgo_dialog_address_placeholder'),
            "submitButtonLabel": Translator.translate('clickandgo_dialog_submit_button_label'),
            "submittingLabel": Translator.translate('clickandgo_dialog_submitting_label'),
            "geolocateButtonLabel": Translator.translate('clickandgo_dialog_geolocate_button_label'),
            "availableStockLabel": Translator.translate('clickandgo_dialog_available_stock_label'),
            "loadingMessage": Translator.translate('clickandgo_dialog_loading_message'),
            "errorMessage": Translator.translate('clickandgo_dialog_error_message'),
            "noStoresMessage": Translator.translate('clickandgo_dialog_no_stores_message'),
            "storeClosedLabel": Translator.translate('clickandgo_dialog_store_closed_label'),
            "storeOpenLabel": Translator.translate('clickandgo_dialog_store_open_label'),
            "storeOpeningHoursLabel": Translator.translate('clickandgo_dialog_store_opening_hours_label'),
            "stockLimitedLabelWithQuantity": Translator.translate('clickandgo_dialog_stock_limited_label_with_quantity'),
            "stockLimitedLabel": Translator.translate('clickandgo_dialog_stock_limited_label'),
            "stockAvailableLabelWithQuantity": Translator.translate('clickandgo_dialog_stock_available_label_with_quantity'),
            "stockAvailableLabel": Translator.translate('clickandgo_dialog_stock_available_label'),
            "stockUnavailableLabel": Translator.translate('clickandgo_dialog_stock_unavailable_label'),
            "noOpeningHoursMessage": Translator.translate('clickandgo_dialog_no_opening_hours_message'),
            "exceptionalDaysLabel": Translator.translate('clickandgo_dialog_exceptional_days_label'),
            "informationLabel": Translator.translate('clickandgo_dialog_information_label'),
            "storeClickAndGoAvailableLabel": Translator.translate('clickandgo_dialog_store_clickandgo_available_label'),
            "storeClickAndGoNotAvailableLabel": Translator.translate('clickandgo_dialog_store_clickandgo_not_available_label'),
            "storePickupButtonLabel": Translator.translate('clickandgo_dialog_store_pickup_button_label'),
            "validationErrorMessage": Translator.translate('clickandgo_dialog_validation_error_message'),

            // Configuration
            "showStorePickupButton": isMposV2 ? false : true, // In MPOS V2 mode, we just want to display the stock info 
            "hideStoreContact": false,
            "displayStockQuantity": false,
            "locale": Translator.locale || navigator.language || 'en-US',
            "maxRange": UNIFY_WIDGET_MAX_RANGE || 100,
            "requireFullAddress": true
        };
    }

    const productInfoForm = document.querySelector('.product-infos-form');
    const productEan = productInfoForm ? productInfoForm.getAttribute('data-product-ean') : '';
    if (unifyWidget) {
        if (productEan) {
            unifyWidget.setAttribute('item-id', productEan);
        } else {
            unifyWidget.removeAttribute('item-id');
        }
    }

    const openButton = document.getElementById('product-open-click-and-go');
    if (openButton && unifyWidget) {
        if (unifyWidgetState.storeAvailabilityOpenButton && unifyWidgetState.storeAvailabilityOpenButton !== openButton) {
            unifyWidgetState.storeAvailabilityOpenButton.removeEventListener('click', handleClickAndGoButtonClick);
        }

        unifyWidgetState.storeAvailabilityOpenButton = openButton;

        // Try to get potential info from the button's parent form (if we're on the product page)
        if (openButton.closest('.product-infos-form') && document.body.classList.contains('product_page')) {
            const productInfoForm = openButton.closest('.product-infos-form');
            const productEan = productInfoForm.getAttribute('data-product-ean');
            if (productEan) {
                unifyWidget.setAttribute('item-id', productEan);
            }
        }

        openButton.removeEventListener('click', handleClickAndGoButtonClick);
        openButton.addEventListener('click', handleClickAndGoButtonClick);
    }
}

// ========================================
// Unify E-reservation Widget
// ========================================
function initUnifyEresaWidget() {
    // Check if the body has a .product_page class, if not, exit
    if (!document.body.classList.contains('product_page')) {
        return;
    }

    const unifyEresaWidget = document.querySelector('unify-ereservation-widget');
    const openButton = document.getElementById('product-open-eresa');

    if (unifyEresaWidget && openButton) {
        if (unifyWidgetState.eresaOpenButton && unifyWidgetState.eresaOpenButton !== openButton) {
            unifyWidgetState.eresaOpenButton.removeEventListener('click', handleEresaButtonClick);
        }
        if (siteCurrency && siteCurrency.code) {
            unifyEresaWidget.currency = siteCurrency.code || '';
        } else {
            console.warn("Site currency not found");
            return;
        }

        if (ID_SITE) {
            unifyEresaWidget.tags = [ { 'key':'website', 'value': ID_SITE } ];
        } else {
            console.warn("Site ID not found");
            return;
        }

        if (currentUserInfo) {
            if (currentUserInfo.context_country_code) unifyEresaWidget.tags.push({ 'key':'context_country_code', 'value': currentUserInfo.context_country_code });
            if (currentUserInfo.context_locale_code) unifyEresaWidget.tags.push({ 'key':'context_locale_code', 'value': currentUserInfo.context_locale_code });
            // Parse the civility from the user info to match the expected values by the widget (MR,MRS, or empty string if not specified or different)
            let civility = '';
            const firstName = (currentUserInfo.client_first_name || '').trim();
            const lastName = (currentUserInfo.client_last_name || '').trim();
            const hasNameInfo = firstName !== '' || lastName !== '';
            if (currentUserInfo.client_civilite) {
                const parsedCivility = currentUserInfo.client_civilite.toLowerCase().replace(/[\s,\.]/g, ''); // Remove spaces, commas, periods and convert to lowercase
                if (parsedCivility == 'm') {
                    civility = 'MR';
                } else if (parsedCivility == 'mme' || parsedCivility == 'mlle') {
                    civility = 'MRS';
                } else {
                    civility = '';
                }
            } else if (hasNameInfo) {
                console.warn("[Unify E-reservation Widget] User civility not found");
            }

            // Build the prefill object for the widget with the user info from the session, to prefill the form in the widget
            let widgetPrefill = {};
            widgetPrefill.civility = civility || '';
            widgetPrefill.firstName = firstName;
            widgetPrefill.lastName = lastName;
            widgetPrefill.email = currentUserInfo.client_email || '';
            widgetPrefill.mobileNumber = currentUserInfo.client_mobile || '';
            widgetPrefill.externalId = currentUserInfo.external_id || '';
            unifyEresaWidget.prefill = widgetPrefill;
        }


        unifyEresaWidget.config = {
            // Translations - shared with Click & Go
            "addressLabel": Translator.translate('clickandgo_dialog_address_label'),
            "addressPlaceholder": Translator.translate('clickandgo_dialog_address_placeholder'),
            "submitButtonLabel": Translator.translate('clickandgo_dialog_submit_button_label'),
            "submittingLabel": Translator.translate('clickandgo_dialog_submitting_label'),
            "geolocateButtonLabel": Translator.translate('clickandgo_dialog_geolocate_button_label'),
            "availableStockLabel": Translator.translate('clickandgo_dialog_available_stock_label'),
            "loadingMessage": Translator.translate('clickandgo_dialog_loading_message'),
            "searchErrorMessage": Translator.translate('clickandgo_dialog_error_message'),
            "noStoresMessage": Translator.translate('clickandgo_dialog_no_stores_message'),
            "storeClosedLabel": Translator.translate('clickandgo_dialog_store_closed_label'),
            "storeOpenLabel": Translator.translate('clickandgo_dialog_store_open_label'),
            "storeOpeningHoursLabel": Translator.translate('clickandgo_dialog_store_opening_hours_label'),
            "stockLimitedLabelWithQuantity": Translator.translate('clickandgo_dialog_stock_limited_label_with_quantity'),
            "stockLimitedLabel": Translator.translate('clickandgo_dialog_stock_limited_label'),
            "stockAvailableLabelWithQuantity": Translator.translate('clickandgo_dialog_stock_available_label_with_quantity'),
            "stockAvailableLabel": Translator.translate('clickandgo_dialog_stock_available_label'),
            "stockUnavailableLabel": Translator.translate('clickandgo_dialog_stock_unavailable_label'),
            "noOpeningHoursMessage": Translator.translate('clickandgo_dialog_no_opening_hours_message'),
            "exceptionalDaysLabel": Translator.translate('clickandgo_dialog_exceptional_days_label'),
            "informationLabel": Translator.translate('clickandgo_dialog_information_label'),
            "validationErrorMessage": Translator.translate('clickandgo_dialog_validation_error_message'),
            "searchValidationErrorMessage": Translator.translate('clickandgo_dialog_validation_error_message'),
            "searchingLabel": Translator.translate('clickandgo_dialog_submitting_label'),

            // Eresa-specific translations
            "dialogTitle": Translator.translate('eresa_dialog_title'),
            "resultDialogTitle": Translator.translate('eresa_result_dialog_title'),
            "dialogDescription": Translator.translate('eresa_dialog_description'),
            "errorMessage": Translator.translate('eresa_dialog_error_message'),
            "selectStoreButtonLabel": Translator.translate('eresa_select_store_button_label'),
            "editButtonLabel": Translator.translate('eresa_edit_button_label'),
            "colorLabel": Translator.translate('eresa_color_label'),
            "sizeLabel": Translator.translate('eresa_size_label'),
            "civilityLabel": Translator.translate('eresa_civility_label'),
            "civilityPlaceholder": Translator.translate('eresa_civility_placeholder'),
            "firstNameLabel": Translator.translate('eresa_first_name_label'),
            "lastNameLabel": Translator.translate('eresa_last_name_label'),
            "emailLabel": Translator.translate('eresa_email_label'),
            "phoneCountryLabel": Translator.translate('eresa_country_label'),
            "phoneNumberLabel": Translator.translate('eresa_phone_number_label'),
            "confirmButtonLabel": Translator.translate('eresa_submit_button_label'),
            "confirmingLabel": Translator.translate('clickandgo_dialog_submitting_label'),
            "formValidationErrorMessage": Translator.translate('eresa_form_validation_error_message'),
            "phoneNumberErrorMessage": Translator.translate('eresa_phone_number_error_message'),
            "finishButtonLabel": Translator.translate('eresa_finish_button_label'),
            "startOverButtonLabel": Translator.translate('eresa_start_over_button_label'),
            "daysRangeLabel": Translator.translate('eresa_days_range_label'),
            "geolocatingLabel": Translator.translate('eresa_geolocating_label'),

            // Configuration
            "hideStoreContact": false,
            "displayStockQuantity": false,
            "locale": Translator.locale || navigator.language || 'en-US',
            "maxRange": UNIFY_WIDGET_MAX_RANGE || 100,
            "requireFullAddress": true
        };

        // Try to get potential info from the button's parent form (if we're on the product page)
        if (openButton.closest('.product-infos-form') && document.body.classList.contains('product_page')) {
            const productInfoForm = openButton.closest('.product-infos-form');
            const productEan = productInfoForm.getAttribute('data-product-ean');
            const productPrice = productInfoForm.getAttribute('data-prixu');
            if (productEan) {
                unifyEresaWidget.setAttribute('item-id', productEan);
            }

            if (productPrice) {
                unifyEresaWidget.price = parseFloat(productPrice);
            }
        }

        unifyWidgetState.eresaWidget = unifyEresaWidget;
        unifyWidgetState.eresaOpenButton = openButton;

        openButton.removeEventListener('click', handleEresaButtonClick);
        openButton.addEventListener('click', handleEresaButtonClick);

        // Remove the style attribute on the widget to avoid showing a non-styled widget before it's fully initialized
        unifyEresaWidget.removeAttribute('style');
    } else {
        openButton?.setAttribute('is-hidden', '');
    }
}

// ========================================
// Unify Stock Widget
// ========================================

function initUnifyStockWidgetProductPage() {
    // Check if the body has a .product_page class AND if isMposV2 is defined and true, if not, exit
    if (!document.body.classList.contains('product_page') || typeof isMposV2 === 'undefined' || !isMposV2) {
        return;
    }

    hideAlertStockButton();
    if (!unifyWidgetState.stockGlobalListenersBound) {
        document.addEventListener('btnAddCart_updated', hideAlertStockButton);
        document.addEventListener('addToBasket_error', handleUnifyStockWidgetAddToBasketError);
        unifyWidgetState.stockGlobalListenersBound = true;
    }

    const unifyWidget = document.querySelector('unify-stock-widget');
    if (unifyWidget) {
        if (unifyWidgetState.stockWidget && unifyWidgetState.stockWidget !== unifyWidget) {
            unifyWidgetState.stockWidget.removeEventListener('add-to-cart', handleUnifyStockWidgetAddToCart);
            unifyWidgetState.stockWidget.removeEventListener('stock-source-change', handleUnifyStockWidgetSourceChange);
        }

        unifyWidgetState.stockWidget = unifyWidget;

        // Add a "add-to-cart-btn" button inside the widget to avoid showing a non-functional button before init
        unifyWidget.innerHTML = `<button slot="add-to-cart-btn" class="btn-submit" type="submit">${Translator.translate('add_to_basket')}</button>`;

        unifyWidget.removeEventListener('add-to-cart', handleUnifyStockWidgetAddToCart);
        unifyWidget.addEventListener('add-to-cart', handleUnifyStockWidgetAddToCart);

        unifyWidget.removeEventListener('stock-source-change', handleUnifyStockWidgetSourceChange);
        unifyWidget.addEventListener('stock-source-change', handleUnifyStockWidgetSourceChange);
    }
}

// Unify Stock Widget - utils functions 

/**
 * Function to gate the add to cart action when using the Unify Stock Widget,
 * to ensure that a stock location has been selected before adding the product to the cart,
 * and to display the stock location selector modal if not.
 * 
 * @param { HTMLFormElement } form - The form element containing the product information and the data-stock-location attribute set by the Unify Stock Widget
 * @returns { HTMLFormElement } form - The same form element, potentially mutated with the selected stock location in the data-stock-location attribute
 */
async function unifyStockCheckHandler({form}) {
    const idProduit = form.getAttribute('data-product-id');
    const idTaille = form.getAttribute('data-product-size');
    const stockLocation = form.hasAttribute('data-stock-location') ? form.getAttribute('data-stock-location') : null;

    // We also want the button inside the Unify Stock Widget slot to be loading while adding to basket
    form.querySelector('[slot="add-to-cart-btn"]')?.setAttribute('is-loading', '');

    // If we don't have a stock location attribute, alert the user, and prompt them to select a store (by opening the stock location selector modal)
    if (stockLocation === null || stockLocation === undefined || stockLocation === 'null') {
        form.querySelector('[slot="add-to-cart-btn"]')?.removeAttribute('is-loading');

        const addToBasketErrorEvent = new CustomEvent('addToBasket_error', {
            detail: {
                idProduit: idProduit,
                idTaille: idTaille,
            }
        });
        document.dispatchEvent(addToBasketErrorEvent);

        try {
            // Open stock location selector modal; when user selects, promptUnifyStockSource resolves with a form copy that has data-stock-location set.
            const formWithLocation = await promptUnifyStockSource({
                form: form,
                message: Translator.translate('item_interaction_choose_stock_source')
            });
            return formWithLocation ?? form;
        } catch (e) {
            console.error('Error displaying stock location selector modal:', e);
            return undefined;
        }
    }

    return form;
}

// ========================================
// Unify Order Details Widget
// ========================================

function initUnifyOrderDetailsWidget() {
    // Check if the body has a .customer class, if not, exit
    if (!document.body.classList.contains('customer')) {
        return;
    }

    const orderDetailsWidget = document.querySelector('unify-order-details-widget');
    if (orderDetailsWidget) {
        orderDetailsWidget.config = {
            "dialogTitle": Translator.translate('order_details_dialog_title'),
            "loadingMessage": Translator.translate('order_details_loading_message'),
            "errorMessage": Translator.translate('order_details_error_message'),
            "noPackageDetails": Translator.translate('order_details_no_package_details'),
            "orderIdLabel": Translator.translate('order_details_order_id_label'),
            "orderDetails": Translator.translate('order_details_order_details'),
            "dateLabel": Translator.translate('order_details_date_label'),
            "packageNumber": Translator.translate('order_details_package_number'),
            "packageStatus": Translator.translate('order_details_package_status'),
            "pendingStatus": Translator.translate('order_details_pending_status'),
            "waitingStatus": Translator.translate('order_details_waiting_status'),
            "processingStatus": Translator.translate('order_details_processing_status'),
            "processedStatus": Translator.translate('order_details_processed_status'),
            "incompletelyProcessedStatus": Translator.translate('order_details_incompletely_processed_status'),
            "refusedStatus": Translator.translate('order_details_refused_status'),
            "canceledStatus": Translator.translate('order_details_canceled_status'),
            "shippedStatus": Translator.translate('order_details_shipped_status'),
            "incompletelyShippedStatus": Translator.translate('order_details_incompletely_shipped_status'),
            "availableInStoreStatus": Translator.translate('order_details_available_in_store_status'),
            "deliveredToCustomerStatus": Translator.translate('order_details_delivered_to_customer_status'),
            "pickupRefusedStatus": Translator.translate('order_details_pickup_refused_status'),
            "incompletelyDeliveredStatus": Translator.translate('order_details_incompletely_delivered_status'),
            "serviceSentStatus": Translator.translate('order_details_service_sent_status'),
            "closedStatus": Translator.translate('order_details_closed_status'),
            "carrierLabel": Translator.translate('order_details_carrier_label'),
            "trackingNumber": Translator.translate('order_details_tracking_number'),
            "trackingNumbers": Translator.translate('order_details_tracking_numbers'),
            "colorLabel": Translator.translate('order_details_color_label'),
            "sizeLabel": Translator.translate('order_details_size_label'),
            "quantityLabel": Translator.translate('order_details_quantity_label'),
            "noProducts": Translator.translate('order_details_no_products'),
            "basketPriceLabel": Translator.translate('order_details_basket_price_label'),
            "shippingPriceLabel": Translator.translate('order_details_shipping_price_label'),
            "totalPriceLabel": Translator.translate('order_details_total_price_label'),
            "deliveryLabel": Translator.translate('order_details_delivery_label'),
            "homeDelivery": Translator.translate('order_details_home_delivery'),
            "storeDelivery": Translator.translate('order_details_store_delivery'),
            "relayDelivery": Translator.translate('order_details_relay_delivery'),
            "noCarrier": Translator.translate('order_details_no_carrier'),
            "shippingAddressLabel": Translator.translate('order_details_shipping_address_label'),
            "billingAddressLabel": Translator.translate('order_details_billing_address_label'),
            "noAddress": Translator.translate('order_details_no_address'),

            "locale": Translator.locale || navigator.language || 'en-US',
            "hidePrice": false
        };
    }
}

// ========================================
// Unify Return Widget
// ========================================

function initUnifyReturnWidget() {
    // Check if the body has a .customer class, if not, exit
    if (!document.body.classList.contains('customer')) {
        return;
    }

    const orderReturnWidget = document.querySelector('unify-return-widget');
    if (orderReturnWidget) {
        orderReturnWidget.config = {
            "dialogTitle": Translator.translate('order_return_dialog_title'),
            "toReturnTitle": Translator.translate('order_return_to_return_title'),
            "toReturnDescription": Translator.translate('order_return_to_return_description'),
            "returnedTitle": Translator.translate('order_return_returned_title'),
            "noProductsToReturn": Translator.translate('order_return_no_products_to_return'),
            "noProductsReturned": Translator.translate('order_return_no_products_returned'),
            "returnReasonLabel": Translator.translate('order_return_return_reason_label'),
            "selectReasonLabel": Translator.translate('order_return_select_reason_label'),
            "sizeLabel": Translator.translate('order_return_size_label'),
            "colorLabel": Translator.translate('order_return_color_label'),
            "errorMessage": Translator.translate('order_return_error_message'),
            "dataFetchError": Translator.translate('order_return_data_fetch_error'),
            'returnsNotEnabledError': Translator.translate('order_return_returns_not_enabled_error'),
            "cannotSubmitWhileLoading": Translator.translate('order_return_cannot_submit_while_loading'),
            "formNotFound": Translator.translate('order_return_form_not_found'),
            "noValidReturnProducts": Translator.translate('order_return_no_valid_return_products'),
            "returnSubmittedSuccessfully": Translator.translate('order_return_return_submitted_successfully'),
            "errorSubmittingReturn": Translator.translate('order_return_error_submitting_return'),
            "legalMentions": Translator.translate('order_return_legal_mentions'),
            "submittingLabel": '', // Empty string to avoid showing any text during submission, since we have a loader
            "ctaLabel": Translator.translate('order_return_cta_label'),
            "documentNameLabel": Translator.translate('order_return_document_name_label'),
            "trackingNumberLabel": Translator.translate('order_return_tracking_number_label'),
            "documentLabelReturnSlip": Translator.translate('order_return_document_label_return_slip'),
            "documentLabelShippingLabel": Translator.translate('order_return_document_label_shipping_label'),
            "documentLabelReturnLabel": Translator.translate('order_return_document_label_return_label'),

            "refreshAfterReturnTimer": 5000,
            "hidePrice": true,
            "locale": Translator.locale || navigator.language || 'en-US'
        };
    }
}

function initUnifyPaymentWidget() {
    // Check if the body has a .checkout class, if not, exit
    if (!document.body.classList.contains('checkout')) {
        return;
    }

    const paymentWidget = document.querySelector('unify-payment-widget');
    if (paymentWidget) {
        paymentWidget.config = {
            'payAtCashRegisterSuccessText': Translator.translate('payment_widget_pay_at_cash_register_success_text'),
            'defaultErrorMessage': Translator.translate('payment_widget_default_error_message'),
            'showErrorDetails': true, // Enable detailed error messages for better debugging
            enabledPaymentMethods: ['cash-register'], // Enable only cash register
        };

        // Try adding the defined order data on the window to the widget
        try {
            if (window.WshopToUnifyOrder) {
                paymentWidget.order = window.WshopToUnifyOrder;
            } else {
                console.warn("[unify_widget.js] No order data found on window to set on Unify Payment Widget");
            }
        } catch (e) {
            console.error("[unify_widget.js] Error setting order data on Unify Payment Widget:", e);
        }


        // Listen for a payment-success event to cleanup the basket 
        paymentWidget.addEventListener('payment-success', () => {
            fetch(path_relative_root + 'ajax_removeBasketProd.php?emptyCart=true', {
            method: 'GET',
            })
            .then(response => response.text())
            .then(resp => {
                console.log('Basket cleared after successful payment:', resp);
            })
            .catch(error => {
                console.error('Error clearing basket after payment:', error);
            });
        });

        // Listen for a payment-error event to log the error
        paymentWidget.addEventListener('payment-error', (event) => {
            console.error('Payment error in Unify Payment Widget:', event.detail);
        });
    }

}

// ========================================
// Helper Functions (to be called externally)
// ========================================

function openOrderDetails(orderId) {
    // Get the order details Unify widget element
    const orderDetailsWidget = document.querySelector('unify-order-details-widget');

    if (!orderDetailsWidget) {
        console.error("Order Details Unify Widget not found");
        return;
    }

    // Set the order ID attribute to load the specific order details
    orderDetailsWidget.setAttribute('order-id', orderId);

    // Open the dialog
    orderDetailsWidget.open = true;
}

function openOrderReturn(orderId) {
    // Get the order return Unify widget element
    const orderReturnWidget = document.querySelector('unify-return-widget');

    if (!orderReturnWidget) {
        console.error("Order Return Unify Widget not found");
        return;
    }

    // Set the order ID attribute to load the specific order return details
    orderReturnWidget.setAttribute('order-id', orderId);
    // Open the dialog
    orderReturnWidget.open = true;
}

// ========================================
// Initialize Unify Widgets when the library is available
// ========================================

function initializeUnifyWidgets() {
    initUnifyEventTracker();
    initUnifyStoreAvailabilityWidget();
    initUnifyEresaWidget();
    initUnifyStockWidgetProductPage();
    initUnifyOrderDetailsWidget();
    initUnifyReturnWidget();
    initUnifyPaymentWidget();

    // Watch the Unify Widgets for preventing layout shifts when opening the dialog
    const widgets = document.querySelectorAll("unify-store-availability-widget, unify-ereservation-widget, unify-order-details-widget, unify-return-widget");
    widgets.forEach(widget => {
        widget.addEventListener("dialog-opened", (e) => {
            if (e.detail.open) {
                document.body.setAttribute("has-scroll-locked", "");
            } else {
                document.body.removeAttribute("has-scroll-locked");
            }
        });
    });
};

import(UNIFY_WIDGET_LIBRARY_URL).then(() => {
    initializeUnifyWidgets();
}).catch((error) => {
    console.error("Error loading Unify Widget library:", error);
});

// ========================================
// onSizeChange Handling for Unify Widgets
// ========================================
document.addEventListener('onItemSizeChange_complete', function (event) {
    const itemForm = event.detail.form;
    if (!!!itemForm) {
        console.error("Item form not found in onItemSizeChange_complete event", event);
        return;
    }

    const isExpress = event.detail.isExpress;
    const itemEan = event.detail.sizeEan;

    if (!!!itemEan) {
        console.error("Item EAN not found in onItemSizeChange_complete event", event);
        return;
    }

    if (!isExpress) {
        // Update the Unify Store Stock widget item-id attribute
        const storeAvailabilityWidget = itemForm.querySelector('unify-store-availability-widget');
        if (storeAvailabilityWidget) {
            storeAvailabilityWidget.setAttribute('item-id', itemEan);
        }

        // Update the Unify E-reservation widget item-id attribute, if present
        const eResaWidget = itemForm.querySelector('unify-ereservation-widget');
        if (eResaWidget) {
            eResaWidget.setAttribute('item-id', itemEan);
        }

        // Update the Unify Stock widget item-id attribute, if present
        const stockWidget = itemForm.querySelector('unify-stock-widget');
        if (stockWidget) {
            stockWidget.setAttribute('item-id', itemEan);
            // Also remove the set stock location to let the user pick it again once the widget has been updated   
            itemForm.setAttribute('data-stock-location', '');
        }
    }
});

// ========================================
// onColorChange/loadProduct Handling for Unify Widgets
// ========================================
function onItemFormUpdated(event) {
    const itemForm = event.detail.form;
    if (!itemForm) {
        return;
    }

    const checkedSize = itemForm.querySelector('input[name="prod_size"]:checked');
    const itemEan = checkedSize ? checkedSize.getAttribute('data-ean') : '';

    if (itemEan) {
        itemForm.setAttribute('data-product-ean', itemEan);
    } else {
        itemForm.setAttribute('data-product-ean', '');
    }

    const storeAvailabilityWidget = itemForm.querySelector('unify-store-availability-widget');
    if (storeAvailabilityWidget) {
        if (itemEan) {
            storeAvailabilityWidget.setAttribute('item-id', itemEan);
        } else {
            storeAvailabilityWidget.removeAttribute('item-id');
        }
    }

    const stockWidget = itemForm.querySelector('unify-stock-widget');
    if (stockWidget) {
        if (itemEan) {
            stockWidget.setAttribute('item-id', itemEan);
        } else {
            stockWidget.removeAttribute('item-id');
        }

        // Reset selected stock source when switching color.
        itemForm.setAttribute('data-stock-location', '');
    }
}

document.addEventListener('onItemColorChange_complete', onItemFormUpdated);
document.addEventListener('loadProduct_complete', onItemFormUpdated);

// ========================================
// btnAddCart_updated Handling for Unify Stock Widget visibility
// ========================================
document.addEventListener('btnAddCart_updated', function (event) {
    const unifyStockWidget = document.querySelector('unify-stock-widget');
    const btnAddCart = event.detail.btnAddCart;
    const btnAlertStock = event.detail.btnAlertStock;
    const isSizeChecked = event.detail.isSizeChecked;
    
    // Check if we're in MPOS V2 mode, and on a product page
    if (typeof isMposV2 !== 'undefined' && isMposV2 && document.body.classList.contains('product_page')) {
        // In MPOS V2 mode, we hide the button when a size is selected, so we can show the widget with the stock information
        if (isSizeChecked) {
            btnAddCart?.setAttribute('is-hidden', '');
            btnAlertStock?.setAttribute('is-hidden', '');
            unifyStockWidget?.removeAttribute('is-hidden');
        } else {
            btnAddCart?.removeAttribute('is-hidden');
            btnAlertStock?.removeAttribute('is-hidden');
            unifyStockWidget?.setAttribute('is-hidden', '');
        }
    }
});

// ========================================
// Utility function to display a Unify Stock Widget dialog with a custom message (used for the "add to cart without size selection" case)
// ========================================

async function promptUnifyStockSource({ message, form }) {
    // Check if we have all the needed data from the form, if not, exit
    if (!form || !form.getAttribute('data-product-ean') || form.getAttribute('data-product-ean') === '' || form.getAttribute('data-product-ean') === 'null') {
        console.error("Form or product EAN not found for Unify Stock Widget dialog!", { form });

        // Try to get the URL of the product page from the form's siblings, not children
        const productPageLink = form.parentElement.querySelector('a')?.getAttribute('href');

        // Ask the user if they want to go to the product page to select a size
        const ppRedirectDialog = document.createElement('dialog');
        ppRedirectDialog.classList.add('unify-stock-widget-redirect-dialog');

        const ppRedirectMessage = document.createElement('p');
        ppRedirectMessage.classList.add('unify-stock-widget-redirect-message');
        ppRedirectMessage.textContent = Translator.translate('item_interaction_choose_stock_source_issue');
        ppRedirectDialog.appendChild(ppRedirectMessage);

        const ppActionContainer = document.createElement('div');
        ppActionContainer.classList.add('unify-stock-widget-redirect-actions');
        ppRedirectDialog.appendChild(ppActionContainer);

        // Only display the product page link if we have it, to avoid confusing the user with a link that doesn't work
        if (productPageLink) {
            const productLinkElem = document.createElement('a');
            productLinkElem.textContent = Translator.translate('item_interaction_redirect_product_page');
            productLinkElem.setAttribute('href',  productPageLink);
            productLinkElem.classList.add('btn-redirect-to-product');
            productLinkElem.classList.add('btn-submit');
            ppActionContainer.appendChild(productLinkElem);
        }

        const ppCancelButton = document.createElement('button');
        ppCancelButton.textContent = Translator.translate('cancel');
        ppCancelButton.classList.add('btn-white');
        ppCancelButton.addEventListener('click', () => {
            ppRedirectDialog.close();
            ppRedirectDialog.remove();
        });
        ppActionContainer.appendChild(ppCancelButton);

        document.body.appendChild(ppRedirectDialog);
        ppRedirectDialog.showModal();
        
        throw new Error('Form or product EAN not found for Unify Stock Widget dialog');
        return;
    }

    // Store the product EAN in a variable for easier access
    const productEan = form.getAttribute('data-product-ean');

    // Return a promise that resolves/rejects based on user interaction
    return new Promise((resolve, reject) => {
        // Create a new instance of the Unify Stock Widget
        const stockWidget = document.createElement('unify-stock-widget');
        stockWidget.setAttribute('item-id', productEan);
        stockWidget.setAttribute('location-id', wshopStoreCode || '');
        stockWidget.setAttribute('mode', 'mixed-basket');    
        stockWidget.setAttribute('api-key', UNIFY_WIDGET_API_KEY || '');

        // Add a button as a slot to trigger the add-to-cart action from the widget
        const addToCartButton = document.createElement('button');
        addToCartButton.setAttribute('slot', 'add-to-cart-btn');
        addToCartButton.textContent = Translator.translate('product_add_cart');
        addToCartButton.classList.add('btn-submit');
        stockWidget.appendChild(addToCartButton);

        // Make a <dialog> element to display the widget in
        const dialog = document.createElement('dialog');
        dialog.classList.add('unify-stock-widget-dialog');

        // Add the message and the widget to the dialog
        const messageElem = document.createElement('p');
        messageElem.textContent = message;
        messageElem.classList.add('unify-stock-widget-message');
        dialog.appendChild(messageElem);
        dialog.appendChild(stockWidget);

        // Add a cancel button to the dialog
        const cancelButton = document.createElement('button');
        cancelButton.textContent = Translator.translate('cancel');
        cancelButton.classList.add('btn-white');
        cancelButton.addEventListener('click', () => {
            dialog.close();
            dialog.remove();
            reject(new Error('User cancelled the dialog'));
        });
        dialog.appendChild(cancelButton);

        // Listen to the add-to-cart event from the widget to trigger the addToBasket function with the selected stock location 
        stockWidget.addEventListener('add-to-cart', (event) => {
            // First, check if we have a source at all, 
            if (!event.detail.source) {
                console.error('Stock source not defined in add-to-cart event from Unify Stock Widget', { event });
                return;
            }
            let selectedStockSource = event.detail.source === 'location' ? event.detail.locationId : '';

            // Explicitly accept empty string as a valid stock location (for the "no stock location" case), but check for undefined or null to avoid issues
            if (typeof selectedStockSource !== 'undefined' && selectedStockSource !== null) {
                // Copy the form instance to avoid manipulating the original form
                let formCopy = form?.cloneNode(true);
                formCopy?.setAttribute('data-stock-location', selectedStockSource);

                addToCartButton.setAttribute('is-loading', '');

                // Start to listen to the custom events "addToBasket_error" and "addToBasket_success" that should be dispatched at the end of the addToBasket function
                // then we close the widget dialog on success or display an error message on failure
                function onAddToBasketError() {
                    console.error('Error adding product to basket with Unify Stock Widget selected stock source');

                    // Remove the widget from the dialog, and display an error message instead
                    document.querySelector('.unify-stock-widget-dialog unify-stock-widget').remove();
                    messageElem?.insertAdjacentHTML('afterend', `
                        <p class="unify-stock-widget-error-message">${Translator.translate('purchase_confirmation_error')}</p>
                    `);

                    // Remove this event listener after it's been executed once
                    document.removeEventListener('addToBasket_success', onAddToBasketSuccess);
                    document.removeEventListener('addToBasket_error', onAddToBasketError);
                }

                function onAddToBasketSuccess() {
                    // Close the Unify Stock Widget dialog
                    const dialog = stockWidget.closest('dialog');
                    if (dialog) {
                        dialog.close();
                        dialog.remove();
                    }

                    // Remove this event listener after it's been executed once
                    document.removeEventListener('addToBasket_success', onAddToBasketSuccess);
                    document.removeEventListener('addToBasket_error', onAddToBasketError);
                }

                document.addEventListener('addToBasket_error', onAddToBasketError);
                document.addEventListener('addToBasket_success', onAddToBasketSuccess);

                // Then, return the Promise to start the add to basket process
                resolve(formCopy);
            }
        });

        // Add the dialog to the body and show it
        document.body.appendChild(dialog);
        dialog.showModal();
    });
}
